import { Injectable } from '@angular/core';

@Injectable()
export class CopyService {

  /**
   * Copies a text to the user's clipboard
   *
   * @param value Value to copy to the user's clipboard
   */
  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value);
  }
}
